import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "fs-22 text-center mb-2" }
const _hoisted_2 = {
  filter: "numeroGiornata",
  sort: "numeroGiornata",
  width: "140"
}
const _hoisted_3 = {
  filter: "note",
  sort: "note",
  width: "180"
}
const _hoisted_4 = {
  key: 0,
  width: "100",
  class: "align-bottom text-end"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { colspan: "99" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "form-control"
}
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "d-flex justify-content-around" }
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "text-end"
}
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_date = _resolveComponent("op-date")!
  const _component_menu_entry = _resolveComponent("menu-entry")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        localizedKey: "Menu giornaliero",
        text: "Menu giornaliero"
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.items
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "N° Giornata",
                text: "N° Giornata"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Note",
                text: "Note"
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
            (_ctx.$store.state.isDoctor() || _ctx.$store.state.isAdmin())
              ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
                  }, " Aggiungi ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.MenuStep[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", null, _toDisplayString(item.dayNumber), 1),
                (_ctx.readonly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$filters.date(item.date, 'dddd DD MMM')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_op_date, {
                        modelValue: item.date,
                        "onUpdate:modelValue": ($event: any) => ((item.date) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
              ]),
              _createElementVNode("td", null, [
                (_ctx.readonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.note), 1))
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((item.note) = $event)
                    }, null, 8, _hoisted_10)), [
                      [_vModelText, item.note]
                    ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.entries, (entry, ii) => {
                    return (_openBlock(), _createBlock(_component_menu_entry, {
                      class: "w-25",
                      readonly: _ctx.readonly,
                      key: i,
                      entry: entry,
                      onRemove: ($event: any) => (_ctx.removeThis(ii, item))
                    }, null, 8, ["readonly", "entry", "onRemove"]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn btn-success",
                      onClick: ($event: any) => (_ctx.addEntry(item))
                    }, " + ", 8, _hoisted_13)
                  ])
                ])
              ]),
              (_ctx.$store.state.isDoctor() || _ctx.$store.state.isAdmin())
                ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                    (!_ctx.readonly)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-sm btn-danger",
                          onClick: ($event: any) => (_ctx.removeItem(i))
                        }, " Rimuovi ", 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ], 64))
}